export const initialLocalState = {
    data: {
        ui: {
            asideHover: false,
            asideMinimize: true,
            asideToggle: false,
            headerToggle: false,
            __typename: "Ui",
        },
    },
};
